import React, { useState } from "react"
import { useSelector } from "react-redux"
import { CourseHeaderDropdownButton } from "./course_header_dropdown_button"
import { CopyCourseModal } from "./copy_course_modal"
import { ComplianceCheckModal } from "./compliance_check_modal"
import { ImportCourseModal } from "./import_course_modal"

export const CourseButtonsRow = () => {
  const addCourseUrl = useSelector((state) => state?.misc?.data?.routes?.addCourseUrl)
  const checkComplianceModalData = useSelector((state) => state?.misc?.data?.complianceCheckModalData)
  const hasCrs = useSelector((state) => state?.misc?.data?.hasCrs)
  const hasScorecentre = useSelector((state) => state?.misc?.data?.hasScorecentre)
  const hasNgf = useSelector((state) => state?.misc?.data?.hasNgf)
  const hasWhsUk = useSelector((state) => state?.misc?.data?.hasWhsUk)
  const hasGenericWhs = useSelector((state) => state?.misc?.data?.hasGenericWhs)
  const hasGolfAdvisor = useSelector((state) => state?.misc?.data?.hasGolfAdvisor)
  const ngfTerminology = useSelector((state) => state?.misc?.data?.ngfTerminology || 'NGF')
  const genericWhsTerminology = useSelector((state) => state?.misc?.data?.genericWhsTerminology || 'WHS')

  const [showCopyModal, setShowCopyModal] = useState(false)
  const [showComplianceCheckModal, setShowComplianceCheckModal] = useState(checkComplianceModalData?.show)
  const [importSource, setImportSource] = useState(null)
  const [showImportModal, setShowImportModal] = useState(false)

  const importSources = [
    { source: "add", label: window.I18n.t("courses.copy_course_modal.add_a_new_course"), enabled: true },
    { source: "crs", label: window.I18n.t("courses.bootstrap_courses.import_from_usga"), enabled: hasCrs },
    { source: "scorecentre", label: window.I18n.t("courses.bootstrap_courses.import_from_score_centre"), enabled: hasScorecentre },
    { source: "ngf", label: window.I18n.t("courses.bootstrap_courses.import_from", { integration_name: ngfTerminology }), enabled: hasNgf },
    { source: "whs_uk", label: window.I18n.t("courses.bootstrap_courses.import_from_whs"), enabled: hasWhsUk },
    { source: "generic_whs", label: window.I18n.t("courses.bootstrap_courses.import_from", { integration_name: genericWhsTerminology }), enabled: hasGenericWhs },
    { source: "golf_advisor", label: window.I18n.t("courses.bootstrap_courses.import_from_golf_now"), enabled: hasGolfAdvisor },
    { source: "copy", label: window.I18n.t("courses.copy_course_modal.copy_in_admin"), enabled: true },
  ].filter((s) => s.enabled)

  const handleImportSelect = (source) => {
    if (source === "add") {
      window.location.href = addCourseUrl
      return
    }
    if (source === "copy") {
      setShowCopyModal(true)
      return
    }
    setImportSource(source)
    setShowImportModal(true)
  }

  const handleImportModalClose = (val) => {
    setShowImportModal(val)
    if (!val) setImportSource(null)
  }

  return (
    <div className="button-row">
      <div className="course-buttons-row-flex">
        {importSources.length > 0 && (
          <CourseHeaderDropdownButton
            text={window.I18n.t("courses.bootstrap_courses.add_a_course")}
            items={importSources}
            onSelect={handleImportSelect}
          />
        )}
      </div>

      {showCopyModal && <CopyCourseModal show={showCopyModal} setShow={setShowCopyModal} />}
      {showComplianceCheckModal && (
        <ComplianceCheckModal
          show={showComplianceCheckModal}
          setShow={setShowComplianceCheckModal}
          modalData={checkComplianceModalData}
        />
      )}
      {showImportModal && importSource && (
        <ImportCourseModal
          show={showImportModal}
          setShow={handleImportModalClose}
          source={importSource}
        />
      )}
    </div>
  )
}
